import { render, staticRenderFns } from "./CalculadoraDiseno.vue?vue&type=template&id=08eaa66a&scoped=true"
import script from "./CalculadoraDiseno.vue?vue&type=script&lang=js"
export * from "./CalculadoraDiseno.vue?vue&type=script&lang=js"
import style0 from "./CalculadoraDiseno.vue?vue&type=style&index=0&id=08eaa66a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08eaa66a",
  null
  
)

export default component.exports